import { Button, Card, Input, Space, Table, Select } from "antd";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { t } from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import { useUser } from "../../core/context/UserContext";
import { debounce } from "lodash";

const { Option } = Select;

export default function UserList() {
    const history = useHistory();
    const [users, setUsers] = useState([]);
    const { firmSettings } = useUser();

    const [enableFilter, setEnableFilter] = useState(true);
    const [searchText, setSearchText] = useState("");

    const getUsers = async (filter = {}) => {
        const res = await ApiService.User.GetUserList(filter);
        if (res.success) {
            setUsers(res.data);
        }
    };

    useEffect(() => {
        getUsers({ Enable: enableFilter, Name: searchText });
    }, []);

    const debouncedSearch = useMemo(
        () =>
            debounce((value) => {
                getUsers({ Enable: enableFilter, Name: value });
            }, 500),
        [enableFilter]
    );

    const renderAction = (row) => (
        <Space>
            <a onClick={() => history.push(`/app/system/users/edit/${row.id}`)}>{t("Edit")}</a>
        </Space>
    );

    return (
        <SimpleLayout>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Button
                        size={"small"}
                        type={"primary"}
                        onClick={() => history.push(`/app/system/users/create`)}
                    >
                        {t("New")}
                    </Button>
                    <Button
                        size={"small"}
                        onClick={() => getUsers({ Enable: enableFilter, Name: searchText })}
                    >
                        {t("Refresh")}
                    </Button>
                    <Select
                        allowClear
                        size="small"
                        placeholder={t("Enable")}
                        style={{ width: 120 }}
                        value={enableFilter}
                        onChange={(value) => {
                            setEnableFilter(value);
                            getUsers({ Enable: value, Name: searchText });
                        }}
                    >
                        <Option value={true}>{t("Active")}</Option>
                        <Option value={false}>{t("Passive")}</Option>
                    </Select>
                    <Input
                        size={"small"}
                        placeholder={t("Search")}
                        value={searchText}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSearchText(value);
                            debouncedSearch(value);
                        }}
                    />
                </Space>

                <Table
                    size={"small"}
                    dataSource={users}
                    pagination={false}
                    rowKey="id"
                    columns={[
                        { key: "name", dataIndex: "name", title: t("Name") },
                        {
                            key: "role",
                            dataIndex: "role",
                            title: t("Role"),
                            render: (_, row) => row?.role?.name,
                        },
                        { key: "#", dataIndex: "#", title: "#", render: (_, row) => renderAction(row) },
                    ]}
                />
            </Card>
        </SimpleLayout>
    );
}